import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
// 判断多个元素是否存在白屏
var isAnyBlank = function(doms) {
    if (!doms || doms.length === 0) {
        return true;
    }
    return _to_consumable_array(doms).some(function(dom) {
        return isBlankDom(dom);
    });
};
// 判断多个元素是否全为白屏
var isAllBlank = function(doms) {
    if (!doms || doms.length === 0) {
        return true;
    }
    return _to_consumable_array(doms).every(function(dom) {
        return isBlankDom(dom);
    });
};
var isBlankDom = function(dom) {
    // 元素不存在, 判定为白屏
    if (!dom) {
        return true;
    }
    // 兼容性判断
    if (typeof getComputedStyle === "function") {
        var style = getComputedStyle(dom);
        // 元素不可见
        if (style.visibility === "hidden" || style.display === "none") {
            return true;
        }
        var rect = dom.getBoundingClientRect();
        // 元素无高度或无宽度
        if (rect.height === 0 || rect.width === 0) {
            // 高度为0 设置了 overflowY hidden，内容不可见，判定为白屏
            if (rect.height === 0 && style.overflowY === "hidden") {
                return true;
            }
            // 宽度为0 设置了 overflowX hidden，内容不可见，判定为白屏
            if (rect.width === 0 && style.overflowX === "hidden") {
                return true;
            }
            // 判断子元素是否白屏
            if (isAllBlank(dom.childNodes)) {
                return true;
            }
        }
        return false;
    }
    // 无法获取计算样式时，简单判断元素是否为空
    return dom.childNodes.length === 0;
};
var BlankScreenPlugin = function(core, params) {
    if (!(core && typeof window === "object" && window)) {
        return;
    }
    var _ref = params || {}, _ref_detectedDom = _ref.detectedDom, detectedDom = _ref_detectedDom === void 0 ? [] : _ref_detectedDom, _ref_threshold = _ref.threshold, threshold = _ref_threshold === void 0 ? 5 : _ref_threshold, _ref_isPolling = _ref.isPolling, isPolling = _ref_isPolling === void 0 ? false : _ref_isPolling;
    var isBlankScreen = false;
    // 判断是否白屏
    var _isBlankScreen = function(el) {
        try {
            var domList = el.map(function(domQuery) {
                return document.querySelector(domQuery);
            }).filter(function(dom) {
                return !!dom;
            }); // 不存在的元素不做判断
            // 是否所有元素都非空白
            return domList.length > 0 ? isAnyBlank(domList) : false;
        } catch (e) {
            return false;
        }
    };
    var timerId;
    if (isPolling) {
        timerId = setTimeout(function run() {
            isBlankScreen = _isBlankScreen(detectedDom);
            if (isBlankScreen) {
                // 出现白屏了就停止继续监测, 并发送日志
                clearTimeout(timerId);
                core.logBlankScreen({});
                return;
            }
            timerId = setTimeout(run, threshold * 1000);
        }, threshold * 1000);
    } else {
        timerId = setTimeout(function() {
            isBlankScreen = _isBlankScreen(detectedDom);
            isBlankScreen && core.logBlankScreen({});
        }, threshold * 1000);
    }
    return function() {
        clearTimeout(timerId);
    };
};
export default BlankScreenPlugin;

 //# sourceMappingURL=index.js.map